import { Moon, Sun } from 'lucide-react';
import { useEffect, useState } from 'react';

const storageKey = 'mecsync-theme';

function applyTheme(theme) {
  const isLight = theme === 'light';
  document.documentElement.classList.toggle('theme-light', isLight);
}

export default function ThemeToggle({ className = '' }) {
  const [theme, setTheme] = useState(() => localStorage.getItem(storageKey) || 'dark');
  const isLight = theme === 'light';
  const Icon = isLight ? Moon : Sun;

  useEffect(() => {
    applyTheme(theme);
    localStorage.setItem(storageKey, theme);
  }, [theme]);

  return (
    <button
      type="button"
      onClick={() => setTheme((current) => (current === 'light' ? 'dark' : 'light'))}
      className={`flex h-9 w-9 items-center justify-center rounded-lg border border-border bg-surface2 text-zinc-400 transition-colors hover:text-white ${className}`}
      aria-label={isLight ? 'Ativar tema escuro' : 'Ativar tema claro'}
      title={isLight ? 'Tema escuro' : 'Tema claro'}
    >
      <Icon size={15} />
    </button>
  );
}
